/** Row keys that should use numeric sort/compare on Talent Discovery (see TalentDiscoveryDataProvider). */
export const TALENT_DISCOVERY_NUMERIC_SORT_KEYS = new Set<string>([
  'salary_base',
  'salary_total',
  'years_of_experience',
  'graduation_year',
]);

export const TALENT_DISCOVERY_VALID_COLUMNS: string[] = [
  'first_name',
  'last_name',
  'email',
  'personal_email',
  'phone_number',
  'current_title',
  'current_company',
  'start_date',
  'end_date',
  'gender',
  'ethnicity',
  'highest_degree',
  'salary_base',
  'salary_total',
  'user_location',
  'prestige',
  'education',
  'remote_suitability',
  'years_of_experience',
  'flight_risk',
  'employment_relationship',
  'work_schedule',
  'linkedin_url',
  'graduation_year',
] as const;

export const TALENT_DISCOVERY_HIDDEN_COLUMNS: string[] = [
  '__typename',
  'original_user_id',
  'user_id',
  'work_history',
  'education_history',
  '__metaData',
  'skills',
] as const;

export const validateTalentDiscoveryColumns = (columns: string[]): string[] => {
  const validColumnSet = new Set(TALENT_DISCOVERY_VALID_COLUMNS);
  const hiddenColumnSet = new Set(TALENT_DISCOVERY_HIDDEN_COLUMNS);

  return columns.filter(
    (col) => validColumnSet.has(col) && !hiddenColumnSet.has(col)
  );
};
